import {doc, onSnapshot, setDoc} from 'firebase/firestore';
import {db} from '../../../shared/services/firebase';
import {fail, logError, ok, toConfigError} from './apiHelpers';

/**
 * Subscribe to real-time device variable updates (CT settings).
 * Returns the unsubscribe function.
 */
export const subscribeToDeviceSettings = (edgeId, onData, onError) => {
  return onSnapshot(
    doc(db, 'edges', edgeId, 'balena', 'deviceVariables'),
    (snapshot) => {
      if (snapshot.exists()) {
        onData(snapshot.data());
      } else {
        onData({});
      }
    },
    (error) => {
      console.error('[configApi:subscribeToDeviceSettings]', error);
      onError?.(error);
    }
  );
};

/**
 * Save current transformer / device variable settings.
 */
export const saveDeviceSettings = async (edgeId, settings) => {
  try {
    await setDoc(doc(db, 'edges', edgeId, 'balena', 'deviceVariables'), settings, {merge: true});
    return ok();
  } catch (error) {
    const errorInfo = toConfigError(error, 'CONFIG_SAVE_FAILED');
    logError('saveDeviceSettings', errorInfo);
    return fail(errorInfo);
  }
};

